module.exports = __webpack_public_path__ + "img/fd_ic_fhdb.2ed6d7ca.svg";